@if (activity.due_at) {
	@if ((currentView$ | async); as currentView) {
		<div class="activity-due-date">
			@if (withDateLabel) {
				<ng-container>
					<span class="due-date-label-full">{{ 'activity-list_due-date' | translate }}:&nbsp;</span>
					<span class="due-date-label-partial">{{ 'activity-list_due' | translate }}:&nbsp;</span>
				</ng-container>
			}

			<span class="due-date" [ngClass]="{'red': isPastDue()}">
				@if (isPastDue()) {
					<span class="ficon-app-warning-circle-outline warning-icon red"
						[matTooltip]="getTooltipStr() | translate"
						matTooltipPosition="above"
						tabindex="0">
					</span>
				}
				@if(currentView === views.LIST) {
					{{ "activity-list_due-date-posted" | translate: {
							"date": activity.due_at | date,
							"time": activity.due_at | date:'shortTime'
						}
					}}
				} @else {
					{{activity.due_at | date: 'MMM d, y'}}
				}

			</span>
		</div>
	}
} @else {
	<span class="no-date">—</span>
}
